window.refreshOrdersify = async function () {
    const getVariantId = () => {
        // A) Dawn-like JSON
        const el = document.querySelector('[data-selected-variant]');
        if (el) {
            try { const id = JSON.parse(el.textContent).id; if (id) return String(id); } catch {}
        }
        // B) URL ?variant=
        const v = new URLSearchParams(location.search).get('variant');
        if (v) return String(v);
        // C) form/select fallback
        const input = document.querySelector('form[action*="/cart/add"] [name="id"], select[name="id"]');
        return input?.value ? String(input.value) : null;
    };

    const getProductPath = () => {
        const vs = document.querySelector('variant-selects[data-url]');
        if (vs?.dataset?.url && /\/products\//i.test(vs.dataset.url)) return vs.dataset.url.replace(/\?.*$/, '');
        const canon = document.querySelector('link[rel="canonical"]')?.href || '';
        let m = canon.match(/https?:\/\/[^/]+(\/(?:[a-z-]+\/)?products\/[^/?#]+)/i);
        if (m) return m[1];
        m = location.pathname.match(/(\/(?:[a-z-]+\/)?products\/[^/?#]+)/i);
        return m ? m[1] : null;
    };

    const readProductFromDOM = () => {
        const s1 = document.querySelector('script[type="application/json"][data-product]');
        if (s1?.textContent) { try { const json = JSON.parse(s1.textContent); if (json?.title) return json; } catch {} }
        const s2 = document.querySelector('script[type="application/json"][data-product-json], script#ProductJson, script#product-json, script[data-product-data]');
        if (s2?.textContent) { try { const json = JSON.parse(s2.textContent); if (json?.title) return json; } catch {} }
        return null;
    };

    const productPath = getProductPath();
    const variantId   = getVariantId();
    if (!productPath || !variantId) return;

    let product = readProductFromDOM();
    if (!product) {
        const url = `${productPath}.js`;
        const res = await fetch(url, { credentials: 'same-origin' });
        if (!res.ok) return;
        const data = await res.json().catch(() => null);
        if (!data || !data.title) return;
        product = data;
    }

    document.querySelectorAll('.osf_inline_button, .ordersify-notify-button').forEach(n => n.remove());
    const oldRoot = document.getElementById('bis-app');
    if (oldRoot) oldRoot.remove();

    const prev = window.ORDERSIFY_BIS || {};
    window.ORDERSIFY_BIS = {
        product,
        currentVariant: { id: String(variantId) },
        popupSetting: prev.popupSetting || {},
        shop: prev.shop || {},
        theme: prev.theme || {},
    };

    const root = document.createElement('div');
    root.id = 'bis-app';
    (document.querySelector('form[action*="/cart/add"]') || document.body).appendChild(root);

    if (typeof window.osfReRenderApp === 'function') {
        try { window.osfReRenderApp(); } catch {}
    }

    const evtName = window.je || 'osf:variant-change';
    try {
        document.body.dispatchEvent(new CustomEvent(evtName, { detail: { variantID: String(variantId) } }));
    } catch {}
};
